import { Injectable } from '@angular/core';
import { ElementMentionables, Mentionables } from '../interfaces/ui-quill-mention.interfaces';

@Injectable()
export abstract class UiQuillMentionContract {
  /** This can be used to manipulate dropdown template based on Mentionable item */
  abstract renderMentionableItem(item: Mentionables, searchTerm: string): string;

  /** Used to determine the context like the tenant and space */
  abstract getContext(): Promise<{ tenant: string; space: string }>;

  /**
   * Provide users on the basis of search text
   *
   * @param {string} searchTerm - Search text to filter out users from the API
   */
  abstract getUsersBySearchText(searchText: string, currentPage?: number): Promise<Array<Mentionables>>;

  /**
   * Provide the users detail information
   *
   * @param { array<string> } uris: User uris
   */
  abstract getUsersByUri(uris: Array<string>): Promise<Array<Mentionables>>;

  /**
   * Things information is used for Element Mentions
   * */
  abstract get allThings(): Promise<ElementMentionables>;

  /** Following three methods are introduced to fetch things more dynamically */
  abstract fetchMore(): Promise<ElementMentionables>;
  abstract fetchSpecificElements(elementUris: Array<string>): Promise<ElementMentionables>;
  abstract fetchSearched(searchTerm: string): Promise<ElementMentionables>;

  /** Optional method to add inaccessible resources */
  addInaccessibleUris?(type: 'People' | 'Things', uris: Array<string>): void;
}
